import { provideHttpClient } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { provideFunnelSampleContentInitializer } from 'shared/src/services/funnel-sample-content.service';
import { PROJECT_NAME, ProjectNames } from 'shared/src/tokens';
import { StatsIGService } from '../../../shared/src/services/stats-ig.service';
import { routes } from './app.routes';
import { QuizRouteReuseStrategy } from './services/quiz-route-reuse-strategy';

export function provideStatsigInitializer() {
  return provideAppInitializer(() => inject(StatsIGService).initializeStatsig());
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(),
    provideAnimations(),
    {
      provide: PROJECT_NAME,
      useValue: ProjectNames.FUNNEL,
    },
    {
      provide: RouteReuseStrategy,
      useClass: QuizRouteReuseStrategy,
    },
    provideFunnelSampleContentInitializer(),
    provideStatsigInitializer(),
  ],
};
